export var MlpEnv = /*#__PURE__*/function (MlpEnv) {
  MlpEnv["DEV"] = "dev";
  MlpEnv["TEST"] = "test";
  MlpEnv["STAGE"] = "stage";
  MlpEnv["PROD"] = "prod";
  return MlpEnv;
}({});
// Grabs process.env.NODE_ENV and returns undefined value if it is not in the enum
// NODE_ENV is a build time only config. Using a build time config is
// prefered over using a runtime config.
export default function getMlpEnv() {
  return Object.values(MlpEnv).find(function (env) {
    return env === process.env.NODE_ENV;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/getMlpEnv.js
// module id = 2868
// module chunks = 11